// CardRoutes.js
import React from "react";
import { Route, Routes } from "react-router-dom";

import ROUTES_NAVIGATION from "./routes";

import AddNewCampaign from "../components/DealerManagement/Admin/CampaignManagement/Campaign/AddCampaign";
import AddNewPublisher from "../components/DealerManagement/Admin/CampaignManagement/Publisher/AddPublisher";
import AddNewSource from "../components/DealerManagement/Admin/CampaignManagement/Source/AddSource";
import CampaignList from "../components/DealerManagement/Admin/CampaignManagement/Campaign";
import Dashboard from "../components/DealerManagement/Admin/Dashboard";
import PublisherList from "../components/DealerManagement/Admin/CampaignManagement/Publisher";
import SourceList from "../components/DealerManagement/Admin/CampaignManagement/Source";
import EditSource from "../components/DealerManagement/Admin/CampaignManagement/Source/EditSource";
import EditPublisher from "../components/DealerManagement/Admin/CampaignManagement/Publisher/EditPublisher";
import EditCampaign from "../components/DealerManagement/Admin/CampaignManagement/Campaign/EditCampaign";

const CampaignRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES_NAVIGATION.ADDNEWCAMPAIGN}
        element={<AddNewCampaign />}
      />
       <Route
        path={ROUTES_NAVIGATION.EDITCAMPAIGN}
        element={<EditCampaign />}
      />
      <Route path={ROUTES_NAVIGATION.ADDNEWSOURCE} element={<AddNewSource />} />
      <Route path={ROUTES_NAVIGATION.EDITSOURCE} element={<EditSource />} />
      <Route
        path={ROUTES_NAVIGATION.ADDPUBLISHER}
        element={<AddNewPublisher />}
      />
      <Route
        path={ROUTES_NAVIGATION.EDITPUBLISHER}
        element={<EditPublisher />}
      />
      <Route path={ROUTES_NAVIGATION.CAMPAIGNLIST} element={<CampaignList />} />
      {/* <Route path={ROUTES_NAVIGATION.CARDDASHBOARD} element={<Dashboard />} /> */}
      {/* <Route path="dashboard" element={<Dashboard />} /> */}
      <Route
        path={ROUTES_NAVIGATION.PUBLISHERLIST}
        element={<PublisherList />}
      />
      <Route path={ROUTES_NAVIGATION.SOURCELIST} element={<SourceList />} />
    </>
  );
};

export default CampaignRoutes;
